<template>
  <div>
    <q-input
      v-model="user.fullAddress.address_line_1"
      :label="$t('form.labels.address')"
      outlined
      :rules="[val => !addressIsRequired || !!val || $t('form.errors.required')]"
      data-test-id="address-line-1-input"
      @focus="$emit('editing')"
    />
    <q-input
      v-model="user.fullAddress.address_line_2"
      class="q-mb-md"
      :label="$t('form.labels.addressLine2')"
      outlined
      data-test-id="address-line-2-input"
      @focus="$emit('editing')"
    />

    <q-input
      v-model="user.fullAddress.city"
      :label="$t('form.labels.city')"
      outlined
      data-test-id="address-city-input"
      :rules="[val => !addressIsRequired || !!val || $t('form.errors.required')]"
      @focus="$emit('editing')"
    />

    <q-input
      v-model="user.fullAddress.state"
      :label="$t('form.labels.state')"
      outlined
      data-test-id="address-state-input"
      :rules="[val => !addressIsRequired || !!val || $t('form.errors.required')]"
      @focus="$emit('editing')"
    />

    <q-input
      v-model="user.fullAddress.post_code"
      :label="$t('form.labels.zipCode')"
      outlined
      data-test-id="address-post-code-input"
      :rules="[val => !addressIsRequired || !!val || $t('form.errors.required')]"
      @focus="$emit('editing')"
    />
  </div>
</template>

<script>
import User from 'src/models/user/User'

export default {
  props: {
    user: {
      type: User,
      required: true
    },
    addressIsRequired: {
      type: Boolean,
      default: true
    }
  },
  emits: ['editing']
}
</script>
